module.exports = __webpack_public_path__ + "img/2.3137a037.png";